import Settings from './Main';

export default Settings;
